import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  TabContent,
  TabPane,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  CustomInput,
} from 'reactstrap';
import {
  ContAffiliation,
  H5Styled,
  ContFilterYear,
  BtnOutlineGreen,
  ContPaginationPage,
} from '../../../../styled-components';
import SearchInput from '../../../../commons/SearchInput';
import generateMonthOptions from '../../../../lib/helpers/generateMonthOptions';
import ReportingModal from '../../../../commons/ReportingModal';
import generateYearOptions from '../../../../lib/helpers/generateYearOptions';
import { useAuth } from '../../../../commons/Auth';
import variables from '../../../../variables';
import generatePaginationOptions from '../../../../lib/helpers/generatePaginationOptions';
import InsurancesRoyaltyTable from '../InsurancesRoyaltyTable';
import TotalInsuranceRevenuesRow from '../TotalRows/TotalTrInsuranceRevenue';

const VarRevInsDetailPresentational = ({
  data = {},
  total,
  profile,
  query,
  onFilter,
}) => {
  const [t] = useTranslation('CONTACTS');
  const [{ newIsAdmin }] = useAuth();
  const { categories = {} } = data;
  const { variableRevenuesInsurance = {} } = categories;
  const { data: dataRevInsurances = [] } = variableRevenuesInsurance;

  const origin = window.location.origin;
  let hash = window.location.hash.split('/');
  hash.pop();
  const prevPath =
    origin +
    '/' +
    hash.join('/') +
    `${query.year ? '?year=' + query.year : ''}`;

  const getVariableRevenuesTotals = (dataRev) => {
    const netTotals = dataRev.reduce((prev, cur) => prev + cur.net, 0);
    const grossTotals = dataRev.reduce((prev, cur) => prev + cur.gross, 0);
    const shareToInvoiceTotals = dataRev.reduce(
      (prev, cur) => prev + (cur.shareToInvoice || 0),
      0
    );
    const adminShareTotals = dataRev.reduce(
      (prev, cur) => prev + cur.adminShare,
      0
    );
    const earnedAdminShareTotals = dataRev.reduce(
      (prev, cur) => prev + cur.earnedAdminShare,
      0
    );
    const billableAdminShareTotals = dataRev.reduce(
      (prev, cur) => prev + cur.billableAdminShare,
      0
    );
    const panoramicaShareTotals = dataRev.reduce(
      (prev, cur) => prev + cur.panoramicaShare,
      0
    );

    return {
      netTotals,
      grossTotals,
      shareToInvoiceTotals,
      panoramicaShareTotals,
      adminShareTotals,
      earnedAdminShareTotals,
      billableAdminShareTotals,
    };
  };

  return (
    <>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <ContFilterYear>
            <Row>
              <Col xs="6">
                <Label>{t('TITLE_FILTER_YEAR')}</Label>
              </Col>
              <Col xs="6">
                <FormGroup>
                  <CustomInput
                    type="select"
                    id="selectYear"
                    name="year"
                    value={query && query.year}
                    onChange={({ target: { value: year } }) =>
                      onFilter({ year })
                    }
                  >
                    {generateYearOptions()}
                  </CustomInput>
                </FormGroup>
              </Col>
            </Row>
          </ContFilterYear>
          <div
            style={{
              fontWeight: 700,
              color: '#333333',
              marginBottom: '20px',
              fontSize: '20px',
            }}
          >
            <a
              style={{
                color: variables.primary,
              }}
              href={prevPath}
            >
              Rendicontazioni
            </a>{' '}
            / <a>{t('INSURANCES:ROYALTIES_TITLE')}</a>
          </div>

          <Row>
            <Col xs="6">
              <H5Styled>{t('INSURANCES:ROYALTIES_TITLE')}</H5Styled>
            </Col>
          </Row>
          <br />

          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_START_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="insuranceStartMonth"
                        name="insuranceStartMonth"
                        value={query && query.insuranceStartMonth}
                        onChange={({
                          target: { value: insuranceStartMonth },
                        }) => onFilter({ insuranceStartMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.policy_code }}
                onFilter={({ search }) => onFilter({ policy_code: search })}
                label={t('SEARCH:POLICY_CODE')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.admin_cf }}
                onFilter={({ search }) => onFilter({ admin_cf: search })}
                label={t('SEARCH:REFERENCE_ID')}
              />
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Stato assicurazione</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="active"
                        name="active"
                        value={query.active}
                        onChange={({ target: { value: active } }) =>
                          onFilter({ active })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="active">Attive</option>
                        <option value="terminated">Scadute</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('SEARCH:AGENCY_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="agencyType"
                        name="agencyType"
                        value={query.agencyType}
                        onChange={({ target: { value: agencyType } }) =>
                          onFilter({ agencyType })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="VITTORIA">VITTORIA</option>
                        <option value="ITAS">ITAS</option>
                        <option value="ITALIANA_ASSICURAZIONI">ITALIANA ASSICURAZIONI</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
          </Row>

          <br />
          <InsurancesRoyaltyTable
            data={dataRevInsurances || []}
            total={total}
            query={query}
            onFilter={onFilter}
            showEmptyTableMessage={true}
            profile={profile}
            bottomRow={
              <TotalInsuranceRevenuesRow
                totals={getVariableRevenuesTotals(dataRevInsurances)}
                route="variable-revenues-insurances"
                activeRoute={false}
              />
            }
          />
          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </TabPane>
      </TabContent>
    </>
  );
};

export default VarRevInsDetailPresentational;
